

























































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IWikiObject as IWiki, IWikiCategory } from "@/@types/wiki/wiki-object";

import BSwitch from "../../app/switchs/b-switch.vue";
import { ILocale } from "@/@types/locale";

@Component({ components: { BSwitch } })
class WikiTableCard extends Vue {
  @Prop({ type: Object, default: null }) wiki!: IWiki;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiCategory>;

  @Inject({ from: "bgFolder", default: null }) readonly bgfolder!: string;
  @Inject({ from: "iconFolder", default: null }) readonly iconFolder!: string;
  @Inject({ from: "categoryFolder", default: null }) readonly cFolder!: string;

  showImage = "";

  get catIcon(): string {
    const cat = this.categorys.find((el) => el._id == this.wiki.category);
    return cat ? cat.src.icon : "";
  }

  get categoryName(): ILocale {
    const cat = this.categorys.find((el) => el._id == this.wiki.category);
    return cat ? cat.name : {};
  }
}
export default WikiTableCard;
